import { CalendarIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIntl } from "react-intl";
import { FormItems } from "./formItems";
import _ from "./ToolbarDraggableItem";

function buildItems(items: any, fieldProps: any[] = [], defaultItems: any[]) {
  let resultItems: any[] = [];

  if (!items) resultItems = defaultItems;

  resultItems = resultItems.map((field: any) => {
    let found = fieldProps.find(
      (overrideField) => field.key === overrideField.key,
    );

    if (found) field.fieldProps = { ...field.fieldProps, ...found.fieldProps };
    return field;
  });

  return resultItems;
}

//TODO: Fields still need to implement

const Toolbar = ({ fields, fieldProps, ...props }) => {
  const [items, setItems]: any = useState([]);
  const { t } = useTranslation();
  const intl = useIntl();

  useEffect(() => {
    setItems(buildItems(fields, fieldProps, FormItems(intl)));
  }, [fields, fieldProps]);

  const ToolbarItem: any = _;
  return (
    <div className=" rounded-lg ">
      <Accordion
        defaultIndex={0}
        className=" rounded-lg shadow-md border  "
        style={{
          height: "80vh",
          backgroundColor: "#f5f5f999",
          overflowY: "scroll",
        }}
        allowToggle
      >
        <h1
          className="p-4  rounded-lg"
          style={{
            fontWeight: "bold",
            fontSize: "28px",
            textAlign: "center",
            marginBottom: "0px",
            backgroundColor: "#f5f5f999",
          }}
        >
          {t("Survey.Toolbox")}
        </h1>

        <AccordionItem
          backgroundColor={"#f5f5f999"}
          className=" border-gray-300 inputFields "
        >
          {({ isExpanded }) => (
            <>
              <AccordionButton _hover={{}} rounded="lg" _focus={{}}>
                <Box
                  className={
                    "text-md p-2 " +
                    `${
                      isExpanded
                        ? "font-bold rounded-2xl  text-blue-600"
                        : " font-bold"
                    }`
                  }
                  flex="1"
                  textAlign="left"
                >
                  {" "}
                  <CalendarIcon mr={2} mb={1} />
                  {t("Survey.InputFields")}
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                {items.map(
                  (item, index) =>
                    index >= 4 && <ToolbarItem data={item} key={item.key} />,
                )}
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
        <AccordionItem
          backgroundColor={"#f5f5f999"}
          className=" border-gray-300 rounded-b-lg informationFields
          "
        >
          {({ isExpanded }) => (
            <>
              <AccordionButton _hover={{}} rounded="lg" _focus={{}}>
                <Box
                  className={
                    "text-md p-2 " +
                    `${
                      isExpanded
                        ? "font-bold rounded-2xl  text-blue-600"
                        : " font-bold"
                    }`
                  }
                  flex="1"
                  textAlign="left"
                >
                  <InfoOutlineIcon mr={2} mb={1} />{" "}
                  {t("Survey.InformationalFields")}
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                {items.map(
                  (item, index) =>
                    index < 4 && <ToolbarItem data={item} key={item.key} />,
                )}
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default Toolbar;
